import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_USER_INFO_SAGA } from "../sagaTypes";
import { loaderAction, currentUserAction, usersListAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_user_info`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetUserInfo(args) {
    const user = yield select(state => state.user);
    const usersList = yield select(state => state.usersList);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);
        formData.append('archive', args.data.archive ? '1' : '0');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если есть список с пользователями, удаляем данные
            if (usersList.length) {
                yield put(usersListAction([]));
            }
            yield put(currentUserAction(response.user));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetUserInfo() {
    yield takeLatest(GET_USER_INFO_SAGA, workerGetUserInfo);
}